import styles from '../TopUpStatusAlertBox.module.css';
import { TopUpStatusAlertBox } from './TopUpStatusAlertBox';
import { Button, Icon } from '@iwoca/orion';
import messages from './Alerts.messages';
import { FormattedMessage } from 'react-intl';
import { H2, Text } from '@ui';
import { getCountry } from '@iwIntlProvider/CountryProvider';

export const TopUpEligibleAlert = ({
    onApplyNowClick,
    branch
}: {
    onApplyNowClick: () => void;
    branch: string;
}) => {
    if (getCountry() === 'UK' && branch === 'INCLUDE')
        return (
            <div
                data-testid="topup-eligible-banner-redesign"
                className="flex items-start gap-s rounded-m border border-secondary-95 bg-secondary-90 p-m min-sm:gap-l min-sm:p-l"
            >
                <Icon
                    icon="rocket"
                    className="mt-xs size-xl shrink-0 fill-core-65"
                />
                <div className="space-y-m">
                    <div className="space-y-s min-sm:space-y-xs">
                        <H2 className="m-0 text-xl font-bold text-primary-10">
                            <FormattedMessage
                                {...messages.topupEligibleAlertTitle}
                            />
                        </H2>

                        <Text className="text-s min-sm:text-m">
                            <FormattedMessage
                                {...messages.topupEligibleAlertSubtitle}
                            />
                        </Text>
                    </div>

                    <Button onClick={onApplyNowClick}>
                        <FormattedMessage {...messages.applyNowCTAText} />
                    </Button>
                </div>
            </div>
        );

    return (
        <TopUpStatusAlertBox
            variant="cancel"
            iconName="userCheck"
            className={styles.blueAlertBox}
            iconClassName={styles.blueAlertBoxIcon}
            description={
                <>
                    <strong>
                        <FormattedMessage
                            {...messages.topupEligibleAlertTitle}
                        />
                    </strong>
                    <FormattedMessage
                        {...messages.topupEligibleAlertSubtitle}
                    />
                </>
            }
            cta={
                <Button variant="tertiary" onClick={onApplyNowClick}>
                    <FormattedMessage {...messages.applyNowCTAText} />
                    <Icon icon="angleRight" />
                </Button>
            }
        />
    );
};
